
define("json!core/mimetype/extensions.json", function(){ return {
    "txt" : "text/plain",
    "htm" : "text/html",
    "html" : "text/html",
    "xhtml" : "application/xhtml+xml",
    "php" : "text/html",
    "css" : "text/css",
    "js" : "application/javascript",
    "json" : "application/json",
    "xml" : "text/xml",
    "rdf" : "text/xml",
    "swf" : "application/x-shockwave-flash",
    "flv" : "video/x-flv",
    "csv" : "text/csv",
    "rtx" : "text/richtext",
    "rtf" : "text/rtf",
    "png" : "image/png",
    "jpe" : "image/jpeg",
    "jpeg" : "image/jpeg",
    "jpg" : "image/jpeg",
    "gif" : "image/gif",
    "bmp" : "image/bmp",
    "ico" : "image/vnd.microsoft.icon",
    "tiff" : "image/tiff",
    "tif" : "image/tiff",
    "svg" : "image/svg+xml",
    "svgz" : "image/svg+xml",
    "zip" : "application/zip",
    "rar" : "application/x-rar-compressed",
    "exe" : "application/x-msdownload",
    "msi" : "application/x-msdownload",
    "cab" : "application/vnd.ms-cab-compressed",
    "mp3" : "audio/mpeg",
    "oga" : "audio/ogg",
    "ogg" : "audio/ogg",
    "aac" : "audio/aac",
    "qt" : "video/quicktime",
    "mov" : "video/quicktime",
    "mp4" : "video/mp4",
    "webm" : "video/webm",
    "ogv" : "video/ogg",
    "pdf" : "application/pdf",
    "psd" : "image/vnd.adobe.photoshop",
    "ai" : "application/postscript",
    "eps" : "application/postscript",
    "ps" : "application/postscript",
    "doc" : "application/msword",
    "rtf" : "application/rtf",
    "xls" : "application/vnd.ms-excel",
    "ppt" : "application/vnd.ms-powerpoint",
    "odt" : "application/vnd.oasis.opendocument.text",
    "ods" : "application/vnd.oasis.opendocument.spreadsheet",
    "woff" : "application/x-font-woff",
    "eot"  : "application/vnd.ms-fontobject",
    "ttf"  : "application/x-font-ttf"
};});

